module.exports = __webpack_public_path__ + "img/tail-spin-results.e05d62af.svg";